import React, { useEffect, useState, useLayoutEffect } from "react";
import PostData from "../../../Api/PostData";
import { NavLink, useNavigate } from "react-router-dom";
import PersonalInfo from "./Personalinfo";
import axios from "axios";
// import warning from '../../../Assets/Img/warning.png'
import Swal from 'sweetalert2'
import './style.css'
import analytics from '../../../firebase.config'
import { getAnalytics, logEvent } from "firebase/analytics";
import Disclaimer from "../../Atoms/Disclaimer";
import GetData from "../../../Api/GetData";
const Confirmation = ({ handleDrctChange, prevStep, values }) => {
  const [sendingReq, setsendingReq] = useState(false);
  const [responseError, setResponseError] = useState('');
  const [errorTab, setShowErrorTab] = useState(false);
  var editFormStatus = localStorage.getItem("editFormStatus")
  var signedEmail = JSON.parse(localStorage.getItem("user"))?.email;

  const [sendingSaveReq, setsendingSaveReq] = useState(false);
  const [showProceedPopup, setShowProceedPopup] = useState(false);
  var CNICFileBackName;
  var CNICFileFrontName;
  var ProofRelationFileName;
  var sendSalerySlipName;
  var CNICFileUnCompressesFrontNamevar;
  var CNICFileUnCompressedBackNamevar;
  var PermanentProofRelationFileparam;
  var MailingProofRelationFileparam;
  var remitanceValue;
  var ProofRelationFileUnCompressedvar;

  var remitanceName;
  var residentValue;
  var EditFormStatusVal = localStorage.getItem("editFormStatus");

  const [error, setError] = useState(false);
  const history = useNavigate();

  function getSecondPart(str) {
    if (str) {
      return str.split("/")[1];
    }
    else {
      return "pdf"
    }
  }


  const handleresidentStatus = () => {
    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {

      return residentValue = "Resident";

    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {

        return residentValue = "Resident"

      }
      else {

        return residentValue = "Non-Resident"

      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {

        return residentValue = "Resident"

      }
      else {

        return residentValue = "Non-Resident"

      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {

        return residentValue = "Resident"

      }
      else {

        return residentValue = "Non-Resident"

      }
    }
  }


  useEffect(() => {

  }, [responseError])


  const openModel = () => {





    // Get the modal
    var modal = document.getElementById("myModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      console.log(span, span[i]);
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }

  };
  const openSaveExitModel = () => {

    Swal.fire({
      title: 'You’re almost there!',
      text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#e5386a',
      // cancelButtonColor: '#d33',
      cancelButtonText: "Continue",
      // showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: 'Exit',
      // denyButtonText: `Don't save`,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {

      history("/");

    })
    // // Get the modal
    // var modal = document.getElementById("SaveExitModal");

    // // Get the <span> element that closes the modal
    // var span = document.getElementsByClassName("close");
    // // When the user clicks the button, open the modal
    // modal.style.display = "block";

    // // When the user clicks on <span> (x) or Close, close the modal

    // for (let i = 0; i < span.length; i++) {
    //   console.log(span, span[i]);
    //   span[i].onclick = function () {
    //     modal.style.display = "none";
    //   };
    // }
    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {
    //   if (event.target == modal) {
    //     modal.style.display = "none";l
    //   }
    // };
  };
  const backTodaskboard = () => {
    logEvent(analytics, 'aof_show_success_press_back_to_dashboard');
    history("/Otp");
  }

  const handleBackBtn = () => {
    logEvent(analytics, 'aof_review_press_back');
    handleDrctChange('step', 5)
  }
  const handlePersonalDetailClick = () => {
    logEvent(analytics, 'aof_review_pers_info_press_edit_button');
    handleDrctChange("step", 2)
  }


  const handleIncomeDetailClick = () => {
    logEvent(analytics, 'aof_review_income_det_press_edit_button');
    handleDrctChange("step", 3)
  }

  const handleDocumentEditClick = () => {
    logEvent(analytics, 'aof_review_documents_press_edit_button');
    handleDrctChange("step", 4)
  }

  const proceedToSubmitModel = () => {
    // Get the modal

    var modal = document.getElementById("proceedSubmitModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");

    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      span[i].onclick = function () {
        modal.style.display = "none";
        logEvent(analytics, 'aof_review_submit_form_press_cancel');

      };


    }
    // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {
    //   if (event.target == modal) {
    //     modal.style.display = "none";
    //   }
    // };
  };

  const openProceedToSubmitModel = async () => {
    logEvent(analytics, 'aof_review_press_submit');

    await setShowProceedPopup(true)
    await proceedToSubmitModel()



  }

  const handleWhatsapp = () => {
    window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
  }



  const handleAPICSuccessScreen = () => {
    // history('/successotp')

    const response = GetData.getSaveAndExistData();
    response.then((value) => {


      if (value?.data?.Stamp == 'OTP-Verified' || value?.data?.Stamp == 'Record-Submitted') {

        history("/successotp");
      }
      else {


        history("/Otp");

      }

    })

  }





  const SaveSubmit = () => {
    setsendingSaveReq(true);

    const res = PostData.SaveAndExit(values, setError, false);
    res
      .then((value) => {
        setsendingSaveReq(false);
        console.log("Res", value);
        if (value.data) {
          openSaveExitModel();
        }
        //   else {
        //     message.error(value.data);
        //   }
      })
      .catch(function (error) {
        setsendingSaveReq(false);
        console.log(error.response);
      });
  };



  const handleSubmit = (e) => {
    console.log(values.ProofRelationFileName, 'EditFormStatusVal===============>>>>>>>>>>>', EditFormStatusVal)

    e?.preventDefault();
    setShowProceedPopup(false)
    setsendingReq(true);
    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
      remitanceValue = "7";
      remitanceName = 'Resident Pakistani'
    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "1"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "2"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "3"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "4"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "5"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "6"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }


    if (values.CNICFileBack || values.CNICFileFront || values.ProofRelationFile || values.SalerySlip || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {



      let fileData = [
        values.CNICFileBack,
        values.CNICFileFront,
        values.ProofRelationFile,
        values.SalerySlip,
        values.CNICFileUnCompressesFrontName,
        values.CNICFileUnCompressedBackName,
        values?.PermanentProofRelationFile,
        values?.MailingProofRelationFile,
        values?.ProofRelationFileUnCompressed
      ]

      let fileResponse
      let counter = 0

      fileData.forEach((element, index) => {
        fileResponse = PostData.FileAndImageUpload(element, setError, true);
        fileResponse.then((value) => {

          let promise = new Promise((resolve, reject) => {



            if (index == 0) {
              CNICFileBackName = value?.data?.fileName
              counter += 1;
            }
            else if (index == 1) {
              CNICFileFrontName = value?.data?.fileName
              counter += 1;

            }
            else if (index == 2) {
              ProofRelationFileName = value?.data?.fileName
              counter += 1;
            }
            else if (index == 3) {
              sendSalerySlipName = value?.data?.fileName
              counter += 1;
              // if(CNICFileFrontName || sendSalerySlipName || CNICFileBackName || ProofRelationFileName){
              //   console.log('inside come----->>>>')
              //   submitForm()

            }
            else if (index == 4) {
              CNICFileUnCompressesFrontNamevar = value?.data?.fileName
              counter += 1;

            }
            else if (index == 5) {
              CNICFileUnCompressedBackNamevar = value?.data?.fileName
              counter += 1;

            }

            else if (index == 6) {
              PermanentProofRelationFileparam = value?.data?.fileName
              counter += 1;

            }
            else if (index == 7) {
              MailingProofRelationFileparam = value?.data?.fileName
              counter += 1;
            }
            else if (index == 8) {
              ProofRelationFileUnCompressedvar = value?.data?.fileName
              counter += 1;
            }
            if (counter == 9) {
              resolve('success')
            }


          })
          promise.then(data => {
            if (data) {
              submitForm()
            }
          })


        })

      })



    }
    else {
      submitForm()

    }

  };

  const submitForm = () => {
    logEvent(analytics, 'aof_review_submit_form_press_proceed');
    // let obj = {
    //   provinceList: values?.residentiaProvinceList,
    //   cityList: values?.residentialCitiesList
    // }
    let header = {
      uid: JSON.parse(localStorage.getItem("user"))?.user_id,
      // when edit is true send it false

      status: values?.editFormStatus == "true" ? false : true,  // status true for submition and false for save and exist andlso if when click from edit btn on dashboard it always false


      // below section for Personal  Detail

      RelationUS: values?.USResident,
      NonRelationUSPAK: values?.TaxPayer,
      RelationOrganization: values?.AssoiciatedEmployee,
      EarnIncome: values?.EarnIncome,
      //ACCOUNT_TYPE: 'NKA',
      //ACCOUNT_TYPE_KEY: 'Normal Account',
      ACCOUNT_TYPE: values?.Type?.value,
      ACCOUNT_TYPE_KEY: values?.Type?.children,

      SALUTATION: values?.Salutations.value ? values?.Salutations.value : "Mr",
      SALUTATION_KEY: values?.Salutations?.children?.toUpperCase() ? values?.Salutations?.children?.toUpperCase() : '',
      firstName: values?.firstName,
      lastName: values?.lastName,
      PLACE_OF_BIRTH: values?.placeOfBirth,
      GENDER: values?.Gender,
      MARITAL_STATUS: values?.MaritalStatus,
      RELATIONSHIP1: values?.Relation?.value,
      RELATIONSHIP1_KEY: values?.Relation?.children,
      FATHER_HUSBAND_NAME: values?.RelativeName,
      DATE_OF_BIRTH: values?.BirthDay,
      NATIONALITY: values?.Citizenship?.value,
      NATIONALITY_KEY: values?.Citizenship?.children,
      // residentialStatus:  values?.Resident?.value,
      residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
      RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
      // Residential Adddrss feilds start
      PERMANENT_ADDRESS_1: values?.Apt,
      PERMANENT_ADDRESS_2: values?.street,

      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,

      PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,

      // Xb: obj ,



      Xd: values?.MailingAddress == false ? "true" : "false",

      MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
      MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,






      COUNTRY: values?.mailCountry?.label,


      // COUNTRY_KEY: values?.country?.label || values?.country?.children,
      COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,



      CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

        (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


      PROVINCE_STATE: values?.MailingAddress == false ?

        ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
          ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


        : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

      PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
      OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
      OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

        (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      // permanent country list

      PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
      COUNTRY1_KEY: values?.country?.label || values?.country?.children,
      PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PROVINCE_KEY: values?.Provinces?.label,
      PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
      PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

      PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
      EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",



      // Mailing Adddrss feilds End

      email: values?.email ? values?.email : signedEmail,
      // email: values?.email ? values?.email : signedEmail,
      // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),

      PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),
      PERMANENT_EMAIL: signedEmail,
      // PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
      relationWithMobileNo: values?.CellPhone,
      number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),
      // number: "03" + values?.Number.slice(-9),

      PROOF_OF_ADDRESS: values?.PermanentProofOfAddressCheckbox == false ? (values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : PermanentProofRelationFileparam ? PermanentProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_TYPE: values?.PermanentProofOfAddressCheckbox == false ? (values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "") : '',

      PROOF_OF_ADDRESS_MAILING: values?.MailingProofOfAddressCheckbox == false ? (values.MailingProofRelationFileName ? values.MailingProofRelationFileName : MailingProofRelationFileparam ? MailingProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_MAILING_TYPE: values?.MailingProofOfAddressCheckbox == false ? (values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : "") : '',



      RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
      RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',
      RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
      relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',


      RELATIVE_PROOF: values?.CellPhone == 2 ? (values.ProofRelationFileName ? values.ProofRelationFileName : ProofRelationFileName) : "",
      RELATIVE_PROOF_UC: ProofRelationFileUnCompressedvar ? ProofRelationFileUnCompressedvar : values?.ProofRelationFileNameUC ? values?.ProofRelationFileNameUC : '',
      NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
      IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
      RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
      RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
      CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
      CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
      CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
      CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

      // *********************   below section for Income Detail  ***************************************
      idType: values?.IDType,
      CNIC: values?.CNIC,
      issueDate: values?.IssueDate,
      DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
      LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
      IBAN: values.IBAN,
      BANK_NAME: values?.BankName,
      // employmentStatus: values.EmploymentStatus,
      EMPLOYER_NAME: values?.CompName,
      OCCUPATION: values?.BussType?.value,
      OCCUPATION_KEY: values?.BussType?.children,
      JOB_TITLE: values?.JobTitle,
      Department: values?.Department,
      OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
      // for Now Employee Apartment is removed from income detail section
      // employeeApt:values?.EmployApt,

      GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value,
      GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children,
      ZAKAT_STATUS: values?.Zakat?.value,
      ZAKAT_STATUS_KEY: values?.Zakat?.children,
      // Remittance: '07',
      // RemittanceKey: "Repatriable",
      Remittance: remitanceValue,
      RemittanceKey: remitanceName,
      // Remittance: values?.BasisOfRemittance?.value,
      // RemittanceKey: values?.BasisOfRemittance?.children,

      SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
      UKN: values?.UKN,
      MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,
      // ************************* below Section for Documentations *****************************************
      // CNIC_FRONT: CNICFileFrontName,
      // CNIC_BACK: CNICFileBackName,
      // ADD_PROOF: sendSalerySlipName,
      // CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : CNICFileFrontName,
      // CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : CNICFileBackName,
      // ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : sendSalerySlipName,


      CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : CNICFileFrontName ? CNICFileFrontName : "",

      CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : CNICFileBackName ? CNICFileBackName : "",

      CNIC_FRONT_UC: CNICFileUnCompressesFrontNamevar ? CNICFileUnCompressesFrontNamevar : values?.CnicFrontUC ? values?.CnicFrontUC : '',

      CNIC_BACK_UC: CNICFileUnCompressedBackNamevar ? CNICFileUnCompressedBackNamevar : values?.CnicBackUC ? values?.CnicBackUC : '',


      ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : sendSalerySlipName ? sendSalerySlipName : "",

      //  below Section for Terms and conditions
      TERMS_CONDITIONS: "Y", //what to send in this?





      // Not found for following


      proofofRelationship: "",
      Client_Code: "",
      TELEPHONE_OFFICE: "",
      TELEPHONE_RESIDENCE: "",
      FAX: "",
      // PERMANENT_COUNTRY: values?.mailCountry?.value,

      PERMANENT_TELEPHONE_OFFICE: "",
      PERMANENT_TELEPHONE_RESIDENCE: "",
      PERMANENT_FAX: "",
      // OTHER_OCCUPATION: "",
      EMP_ADD_PROOF: "",
      SIGNATURE_PROOF: "",
      // TERMS_CONDITIONS: "",
      ProofofIBAN: "",
      // ZAKAAT_DECLARATION: "",
      // Remittance: "",

      // These are to be send empty for Now
      Salutation_ATR: "",
      CLIENT_NAME_ATR: "",
      IDENTIFICATION_ATR: "",
      CNIC_ATR: "",
      CNIC_EXPIRY_DATE_ATR: "",
      CNIC_LIFETIME_ATR: "",
      Mobile_ATR: "",
      Email_ATR: "",
      Mailing_ADDRESS_ATR_1: "",
      Mailing_ADDRESS_ATR_2: "",
      Mailing_ADDRESS_ATR_3: "",
      Mailing_Country_ATR: "",
      Mailing_Province_ATR: "",
      Other_Mailing_Prov_ATR: "",
      Mailing_CITY_ATR: "",
      Other_Mailing_CITY_ATR: "",
      Landline_ATR: "",
      FAX_ATR: "",
      COMP_STATUS: "false"


      // Stamp:"OTP-Awaiting"
    };
    console.log(values, 'on confirmation response are ----------->>', header)
    let subRequest = axios
      .post("account-details/", header)
      .then((value) => {
        setsendingReq(false);


        if (value?.data?.message) {
          setResponseError(value?.data?.message)
          setShowErrorTab(true)


        }


        if (value?.status == 200) {

          if (values?.editFormStatus == "true") {
            console.log('on confirmation response are  if----------->>', value)
            openModel();
          }
          else if ((value?.data?.BDService?.data?.Message?._text).includes("200") == true || (value?.data?.BDService?.data?.Message?._text).includes("229") == true) {
            console.log('on confirmation response are  else if----------->>', value)
            logEvent(analytics, 'aof_show_success');
            openModel();
          }

          else {
            setShowErrorTab(true)
            logEvent(analytics, 'aof_review_show_persistent_error');
            console.log('on confirmation response are  else----------->>', value)
            setResponseError(value?.data?.BDService?.data?.Message?._text)



          }

        }





        // if (values?.editFormStatus == "true" && value?.status == 200) {
        //   console.log('on confirmation response are  if----------->>', value)
        //   openModel();
        // }
        // else if ((value?.data?.BDService?.data?.Message?._text).includes("200") == true || (value?.data?.BDService?.data?.Message?._text).includes("229") == true) {
        //   console.log('on confirmation response are  else if----------->>', value)
        //   logEvent(analytics, 'aof_show_success');
        //   openModel();
        // }

        // else {
        //   setShowErrorTab(true)
        //   logEvent(analytics, 'aof_review_show_persistent_error');
        //   console.log('on confirmation response are  else----------->>', value)
        //   setResponseError(value?.data?.BDService?.data?.Message?._text)



        // }


      })
      .catch(function (error) {

        setsendingReq(false);
        console.log("catch exception", error);
        // setShowErrorTab(true)

        logEvent(analytics, 'aof_review_show_persistent_error');
        // setResponseError(error.response?.data?.message)
      });

  }


  return (
    <div className="container-fluid px-0 bg-grey-100 py-5">
      <PersonalInfo handleDrctChange={handleDrctChange} values={values} />
      <div className="container px-0">
        <div >
          <div className="px-2">
            {/* <div className="d-inline-flex w-100">
              <p className="fs32 fw-800 ls4 t-grey-800">Review Application</p>
            </div> */}


            <div className="d-inline-flex w-100 mt80 mb40">
              <h1 className="fs32 ls4 fw-800 t-grey-800">Review Application</h1>
            </div>







            <div className="accordion" id="accordionExample">


              <div className="accordion-item my-3 border-0 p-4 edge">
                <h2 className="accordion-header" id="headingZero">

                  <button
                    className="accordion-button fs18 fw-800 t-grey-800 bg-transparent px-0 "
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseZero"
                    aria-expanded="true"
                    aria-controls="collapseZero"
                  >
                    Eligibility
                  </button>
                </h2>
                <div
                  id="collapseZero"

                  className="accordion-collapse collapse show"
                  // className="accordion-collapse collapse show col-lg-12 col-md-6 col-6"
                  aria-labelledby="headingZero"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body px-0">
                    {/* <div className="accordion-body px-0 col-lg-12 col-md-12 col-12 "> */}

                    <div className="row">
                      <div className="col-lg-12 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Are you a U.S. resident or U.S. citizen or a U.S. green card holder or were born in the U.S.?
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">{values?.USResident == 'N' ? 'No' : 'Yes'}</p>
                      </div>
                      <div className="col-lg-12 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0 ">Are you a taxpayer or citizen or a permanent resident of any country apart from the U.S. and Pakistan?
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">{values.TaxPayer == 'N' ? 'No' : 'Yes'}</p>
                      </div>
                      <div className="col-lg-12 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Do you or a close family member or somebody you are closely associated with currently hold or has ever held a post in the below listed organizations?

                        </p>
                        <ul className=" t-grey-400 ls5 flex11-auto mt8">
                          <li>Government</li>
                          <li>Judiciary (Magistrate, District, Session, High Court or Supreme Court judge)</li>
                          <li>Military</li>
                          <li>State-owned corporations (OGDC, PPL, PIA, WAPDA and etc)</li>
                          <li>Political party</li>
                          <li>Associated with International Organizations or Non-Government Organizations (NGOs)</li>
                          <li>Government secret agencies</li>
                        </ul>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.AssoiciatedEmployee == 'N' ? 'No' : 'Yes'}
                        </p>
                      </div>


                      <div className="col-lg-12 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Do you earn an income? Example: you earn a salary, own a business, have savings, collect rental payments, earn a pension or freelance.
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.EarnIncome == 'N' ? 'No' : 'Yes'}
                        </p>
                      </div>

                    </div>


                    <button
                      className="btn-outlined fs16 px-3 py-2 w-sm-100"
                      onClick={() => handleDrctChange("step", 1)}
                    >
                      Edit
                    </button>

                  </div>
                </div>
              </div>





              <div className="accordion-item my-3 border-0 p-4 edge">
                <h2 className="accordion-header p-0" id="headingOne">
                  <button
                    className="accordion-button fs18 fw-800 t-grey-800 bg-transparent px-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    Personal information
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div className="row mt28">
                    {" "}
                    <div className="col-lg-3 col-md-12 col-12">
                      <p className=" fw-500 fs16 t-grey-400 mb0">Salutation</p>
                      <p className=" fw-800 fs16 t-grey-800 Bold">
                        {values?.Salutations?.children}
                      </p>
                    </div>
                    <div className="col-lg-3 col-md-12 col-12">
                      <p className=" fw-500 fs16 t-grey-400 mb0">Full Legal Name</p>
                      <p className=" fw-800 fs16 t-grey-800 Bold">
                        {values?.firstName}
                      </p>
                    </div>

                    <div className="col-lg-3 col-md-12 col-12">
                      <p className=" fw-500 fs16 t-grey-400 mb0">Preferred Name</p>
                      <p className=" fw-800 fs16 t-grey-800 Bold">
                        {values.lastName}
                      </p>
                    </div>
                    <div className="col-lg-2 col-md-12 col-12">
                      <p className=" fw-500 fs16 t-grey-400 mb0">Gender</p>
                      <p className=" fw-800 fs16 t-grey-800 Bold">
                        {values.Gender}
                      </p>
                    </div>
                    <div className="col-lg-3 col-md-12 col-12">
                      <p className=" fw-500 fs16 t-grey-400  mb0">Marital Status</p>
                      <p className=" fw-800 fs16 t-grey-800 Bold">
                        {values.MaritalStatus === 'M' ? 'Married' : 'Single'}
                      </p>
                    </div>


                  </div>
                  <div className="col-lg-12 col-md-12 col-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Provide Father's or Husband's Name</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.Relation.children}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Father / Husband Full Name
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.RelativeName}
                        </p>{" "}
                      </div>
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Date of Birth (e.g. 28-02-1995)</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.BirthDay}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Place of Birth</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.placeOfBirth}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Citizenship</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.Citizenship?.children}
                        </p>
                      </div>
                      {values?.Resident?.children &&
                        <div className="col-lg-3 col-md-12 col-12">
                          <p className=" fw-500 fs16 t-grey-400 mb0">Resident Status in Pakistan </p>

                          <p className=" fw-800 fs16 t-grey-800 Bold">
                            {values?.Resident?.children}
                            {/* {handleresidentStatus()} */}


                          </p>
                        </div>
                      }
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Account Type</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          Normal Account
                          {/* {values?.Type?.children} */}
                        </p>
                      </div>

                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Area
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.street}
                          {/* {values.Provinces.label},{values.country.label} */}
                        </p>
                      </div>



                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Email Address</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {signedEmail}
                        </p>
                      </div>




                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-12">
                    <div className="row">

                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">House & Street</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.Apt} {values?.PermannentAddressLine3}


                        </p>
                      </div>


                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Country</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.country.label}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Province / State</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.Provinces?.label}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">City</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">{values?.City?.label}</p>
                      </div>




                    </div>
                  </div>
                  <div className="col-lg-12 col-md-6 col-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Phone Number Owned by
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.CellPhone === '1' ? 'Self Owned' : 'Other'}
                        </p>
                      </div>

                      <div className="col-lg-3 col-md-12 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Phone Number</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.Number}
                        </p>
                      </div>

                      {values.CellPhone === '2' &&

                        <>
                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Other Relative</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.proofRelation?.children}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Other Relative Name</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.ProofRelationName}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Other Relative CNIC</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.RelativeCNIC}
                            </p>
                          </div>
                        </>
                      }
                      {values.MailingAddress == false && <>
                        <div className="col-lg-3 col-md-12 col-12">
                          <p className=" fw-500 fs16 t-grey-400 mb0">
                            Mailing Address
                          </p>
                          {values?.Mailstreet ? (
                            <>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                <>
                                  {values?.MailApt},{values?.Mailstreet}, {values?.MailingAddressLine3}
                                  {values?.MailCity?.label},{values?.MailProvinces?.label},
                                  {values?.mailCountry?.label}
                                </>
                              </p>
                            </>
                          ) : (
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              <>
                                {values?.Apt}  {values?.street} {values?.Provinces?.label} {values?.country?.label} {values?.MailingAddressLine3}
                              </>
                            </p>
                          )}

                        </div>

                      </>}


                      {values?.addnominee == true &&

                        <>
                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Nominee Name</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.NomineeName}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Relationship with Nominee</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.NomineeRelation?.children}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">ID Type</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.NomineeIDType}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">ID Number</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.NomineeIDNumber}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-12 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Date of Issue</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.NomineeIssueDate}
                            </p>
                          </div>



                          <div className="col-lg-3 col-md-6 col-12">


                            <p className="fw-500 fs16 t-grey-400 mb0">
                              Expiry Date (e.g. 28-02-1995)
                            </p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">

                              {values?.NomineeLifeTimeExpiry == true ? "Life Time Expiry" : values.NomineeExpiryDate}
                              {/* {values.ExpiryDate} */}
                            </p>
                          </div>


                        </>
                      }

















                    </div>
                  </div>

                  <div className="accordion-body px-0">
                    <div className="">
                      {/* <p className="col-sm-3 fw-500 fs16 t-grey-400">
                        Postal Code
                      </p>
                      <p className="col-sm-3 fw-500 fs16 t-grey-800">
                        {values.Zip}
                      </p> */}
                    </div>
                  </div>
                  <button
                    className="btn-outlined fs16 px-3 py-2 w-sm-100 "
                    // onClick={() => handleDrctChange("step", 2)}
                    onClick={() => handlePersonalDetailClick()}
                  >
                    Edit
                  </button>
                </div>
              </div>

              <div className="accordion-item my-3 border-0 p-4 edge">
                <h2 className="accordion-header" id="headingTwo">
                  <button
                    className="accordion-button fs18 fw-800 t-grey-800 bg-transparent px-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Income Details
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body px-0 col-lg-12 col-md-12 col-12 ">
                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Identity Document</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">{values?.IDType} Number</p>
                      </div>
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0 ">{values?.IDType} </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">{values.CNIC}</p>
                      </div>
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">Issue Date (e.g. 28-02-1995)</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.IssueDate}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-6 col-12">


                        <p className="fw-500 fs16 t-grey-400 mb0">
                          Expiry Date (e.g. 28-02-1995)
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">

                          {values?.lifeTimeExpiry == true ? "Life Time Expiry" : values.ExpiryDate}
                          {/* {values.ExpiryDate} */}
                        </p>
                      </div>

                      {/* <div className="col-lg-2 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Employment Status
                        </p>

                        <p className=" fw-800 fs16 t-grey-800">
                          {values.EmploymentStatus == undefined ? 'Employed' : values.EmploymentStatus}
                        </p>
                      </div> */}
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Source Of Income
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.sourceofincome}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className="fw-500 fs16 t-grey-400 mb0">IBAN Number</p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.IBAN}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className="fw-500 fs16 t-grey-400 mb0"> Bank Name  </p>
                        {/* <p className="fw-500 fs16 t-grey-400 mb0">{values?.showOtherBankFeild == false ? 'Mapped' : "User Defined"} Bank Name  </p> */}
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values?.BankName}
                        </p>
                      </div>
                      <div className="col-lg-3 col-md-6 col-12">
                        <p className=" fw-500 fs16 t-grey-400 mb0">
                          Business / Employer Name
                        </p>
                        <p className=" fw-800 fs16 t-grey-800 Bold">
                          {values.CompName}
                        </p>
                      </div>


                    </div>


                    {/* <p className="col-sm-3 fw-500 fs16 t-grey-400">Bank</p>
                      <p className="col-sm-3 fw-500 fs16 t-grey-800">
                        {values.Bank}
                      </p> */}

                    {/* {values.EmploymentStatus == "Employed"  ? ( */}
                    <>
                      <div className="accordion-body px-0 col-lg-12 col-md-12 col-12 ">
                        <div className="row">
                          <div className="col-lg-3 col-md-6 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">
                              Job Title
                            </p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values.JobTitle}
                            </p>
                          </div>
                          <div className="col-lg-3 col-md-6 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">
                              Department
                            </p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values?.Department}
                            </p>
                          </div>
                          <div className="col-lg-3 col-md-6 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">
                              Business / Employer Address
                            </p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values.EmployApt}
                              {values.EmployStreet}
                            </p>
                          </div>

                          <div className="col-lg-3 col-md-6 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">
                              Occupation
                            </p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values.BussType.children}
                            </p>
                          </div>


                          {values.BussType.children == 'Other' &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                Other Occupation
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values.OtherOccupation}
                              </p>
                            </div>
                          }

                          <div className="col-lg-3 col-md-6 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">
                              Gross Annual Income
                            </p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values.AnnualIncome.children}
                            </p>
                          </div>
                          <div className="col-lg-3 col-md-6 col-12">
                            <p className=" fw-500 fs16 t-grey-400 mb0">Zakat Based Deductions</p>
                            <p className=" fw-800 fs16 t-grey-800 Bold">
                              {values.Zakat.children}
                            </p>
                          </div>


                          {values?.BasisOfRemittance?.children &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                Withdrawing Funds out of Pakistan
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values?.BasisOfRemittance?.children}
                              </p>
                            </div>
                          }

                          {values?.UKN &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                UKN
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values?.UKN}
                              </p>
                            </div>
                          }

                          {values?.MOTHER_MAIDEN_NAME &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                Mother Maiden Name
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values?.MOTHER_MAIDEN_NAME}
                              </p>
                            </div>
                          }

                          {values?.ewalletprovider?.children &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                E-Wallet Provider
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values?.ewalletprovider?.children}
                              </p>
                            </div>
                          }

                          {values?.otherewalletprovider &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                Other E-Wallet Provider
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values?.otherewalletprovider}
                              </p>
                            </div>
                          }

                          {values?.ewalletnumber &&
                            <div className="col-lg-3 col-md-6 col-12">
                              <p className=" fw-500 fs16 t-grey-400 mb0">
                                E-Wallet Number
                              </p>
                              <p className=" fw-800 fs16 t-grey-800 Bold">
                                {values?.ewalletnumber}
                              </p>
                            </div>
                          }






                        </div>
                      </div>

                    </>
                    {/* // ) : (
                    //   <></>
                    // )} */}

                    <button
                      className="btn-outlined fs16 px-3 py-2  w-sm-100"
                      // onClick={() => handleDrctChange("step", 3)}
                      onClick={() => handleIncomeDetailClick()}
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
              <div className="accordion-item my-3 border-0 p-4 edge">
                <h2 className="accordion-header" id="headingThree">
                  <button
                    className="accordion-button fs18 fw-800 t-grey-800 bg-transparent px-0 collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Documents Review
                  </button>
                </h2>

                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body px-0">


                    {/* <p className="fs18 fw-500 t-grey-400 my-3">Proof of Relation</p> */}



                    {values?.ProofRelationFileName ? (<>
                      <p className="fs18 fw-500 t-grey-400 my-3">Proof of Relation</p>
                      <div className="d-block d-sm-table">
                        <div className="Circularprogress yellow">
                          {" "}
                          <span className="Circularprogress-left">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>{" "}
                          <span className="Circularprogress-right">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>
                          <div className="Circularprogress-value t-pink fs12 fw-400">
                            PDF
                          </div>
                        </div>

                        <div className="fileName">
                          <div>
                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                              {" "}
                              {values?.ProofRelationFileName}
                            </p>

                          </div>
                        </div>
                      </div>

                    </>
                    ) : (
                      <>

                        {Object.keys(values.ProofRelationFile).map((x) => {

                          return (
                            <>
                              <p className="fs18 fw-500 t-grey-400 my-3">Proof of Relation</p>
                              <div className="d-block d-sm-table">
                                <div className="Circularprogress yellow">
                                  <span className="Circularprogress-left">
                                    <span className="Circularprogress-bar"></span>
                                  </span>
                                  <span className="Circularprogress-right">
                                    <span className="Circularprogress-bar"></span>
                                  </span>

                                  <div className="Circularprogress-value t-pink fs12 fw-400">
                                    {getSecondPart(
                                      values.ProofRelationFile[x].type
                                    ).toUpperCase()}
                                  </div>
                                </div>

                                <div className="fileName">
                                  <div>
                                    <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                      {values.ProofRelationFile[x].name}
                                    </p>
                                    <div>
                                      <p className="m-0 t-grey-400 fw-400 fs14 text-center ">
                                        {Math.round(
                                          values.ProofRelationFile[x].size / 1024
                                        )}
                                        kb /
                                        {Math.round(
                                          values.ProofRelationFile[x].size / 1024
                                        )}
                                        kb
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </>
                    )}


                    {/* permanent and mailing proof of address start */}


                    {values?.PermanentProofRelationFileName ? (
                      <>
                        <p className="fs18 fw-500 t-grey-400 my-3">Permanent Proof of Address</p>
                        <div className="d-block d-sm-table">
                          <div className="Circularprogress yellow">
                            {" "}
                            <span className="Circularprogress-left">
                              {" "}
                              <span className="Circularprogress-bar"></span>{" "}
                            </span>{" "}
                            <span className="Circularprogress-right">
                              {" "}
                              <span className="Circularprogress-bar"></span>{" "}
                            </span>
                            <div className="Circularprogress-value t-pink fs12 fw-400">
                              JPEG
                            </div>
                          </div>

                          <div className="fileName">
                            <div>
                              <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                {" "}
                                {values?.PermanentProofRelationFileName}
                              </p>

                            </div>
                          </div>
                        </div>

                      </>
                    ) : (
                      <>
                        {values.PermanentProofRelationFile ? (
                          <>
                            <p className="fs18 fw-500 t-grey-400 my-3">Permanent Proof of Address</p>
                            {Object.keys(values.PermanentProofRelationFile).map(
                              (x, index) => {

                                return (
                                  <>
                                    <div className="d-block d-sm-table">
                                      <div className="Circularprogress yellow">
                                        {" "}
                                        <span className="Circularprogress-left">
                                          {" "}
                                          <span className="Circularprogress-bar"></span>{" "}
                                        </span>{" "}
                                        <span className="Circularprogress-right">
                                          {" "}
                                          <span className="Circularprogress-bar"></span>{" "}
                                        </span>
                                        <div className="Circularprogress-value t-pink fs12 fw-400">
                                          {getSecondPart(
                                            values.PermanentProofRelationFile[x].type
                                          ).toUpperCase()}
                                        </div>
                                      </div>

                                      <div className="fileName">
                                        {/* <div className="position-absolute ml-55"> */}
                                        <div >
                                          <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                            {" "}
                                            {values.PermanentProofRelationFile[x].name}
                                          </p>
                                          <div>
                                            <p className="m-0 t-grey-400 fw-400 fs14 ">
                                              {" "}
                                              {Math.round(
                                                values.PermanentProofRelationFileSize / 1024
                                              )}{" "}
                                              kb /
                                              {Math.round(
                                                values.PermanentProofRelationFileSize / 1024
                                              )}{" "}
                                              kb
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </>
                                );
                              }
                            )}
                          </>
                        ) : (
                          <>
                            {/* <input
                              type="file"
                              name="PermanentProofRelationFile"

                              onChange={handleChange}
                              value={values.PermanentProofRelationFile}
                              // onChange={(e) => onFileResize(e)}
                              className="custom-file-input "
                              accept=".jpg, .jpeg, .png"
                              required={true}
                            /> */}


                            {/* <label>
                                  The file uploaded must either be a PNG or JPEG file and must be 5 MB or smaller
                                  </label> */}

                          </>

                        )}

                      </>
                    )}




                    {/* *********************** mailig ***************** */}

                    {values?.MailingProofRelationFileName ? (
                      <>
                        <p className="fs18 fw-500 t-grey-400 my-3">Mailing Proof of Address</p>
                        <div className="d-block d-sm-table">
                          <div className="Circularprogress yellow">
                            {" "}
                            <span className="Circularprogress-left">
                              {" "}
                              <span className="Circularprogress-bar"></span>{" "}
                            </span>{" "}
                            <span className="Circularprogress-right">
                              {" "}
                              <span className="Circularprogress-bar"></span>{" "}
                            </span>
                            <div className="Circularprogress-value t-pink fs12 fw-400">
                              JPEG
                            </div>
                          </div>

                          <div className="fileName">
                            <div>
                              <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                {" "}
                                {values?.MailingProofRelationFileName}
                              </p>

                            </div>
                          </div>
                        </div>

                      </>
                    ) : (
                      <>
                        {values.MailingProofRelationFile ? (
                          <>
                            <p className="fs18 fw-500 t-grey-400 my-3">Mailing Proof of Address</p>
                            {Object.keys(values.MailingProofRelationFile).map(
                              (x, index) => {

                                return (
                                  <>
                                    <div className="d-block d-sm-table">
                                      <div className="Circularprogress yellow">
                                        {" "}
                                        <span className="Circularprogress-left">
                                          {" "}
                                          <span className="Circularprogress-bar"></span>{" "}
                                        </span>{" "}
                                        <span className="Circularprogress-right">
                                          {" "}
                                          <span className="Circularprogress-bar"></span>{" "}
                                        </span>
                                        <div className="Circularprogress-value t-pink fs12 fw-400">
                                          {getSecondPart(
                                            values.MailingProofRelationFile[x].type
                                          ).toUpperCase()}
                                        </div>
                                      </div>

                                      <div className="fileName">
                                        {/* <div className="position-absolute ml-55"> */}
                                        <div >
                                          <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                            {" "}
                                            {values.MailingProofRelationFile[x].name}
                                          </p>
                                          <div>
                                            <p className="m-0 t-grey-400 fw-400 fs14 ">
                                              {" "}
                                              {Math.round(
                                                values.MailingProofRelationFileSize / 1024
                                              )}{" "}
                                              kb /
                                              {Math.round(
                                                values.MailingProofRelationFileSize / 1024
                                              )}{" "}
                                              kb
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </>
                                );
                              }
                            )}
                          </>
                        ) : (
                          <>
                            {/* <input
                              type="file"
                              name="MailingProofRelationFile"

                              onChange={handleChange}
                              value={values.MailingProofRelationFile}
                              // onChange={(e) => onFileResize(e)}
                              className="custom-file-input "
                              accept=".jpg, .jpeg, .png"
                              required={true}
                            /> */}


                          </>

                        )}

                      </>
                    )}

                    {/* permanent and mailing proof of address end */}














                    <p className="fs18 fw-500 t-grey-400 my-3">CNIC</p>

                    {values?.CNICFileFrontName ? (<>
                      <div className="d-block d-sm-table">
                        <div className="Circularprogress yellow">
                          {" "}
                          <span className="Circularprogress-left">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>{" "}
                          <span className="Circularprogress-right">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>
                          <div className="Circularprogress-value t-pink fs12 fw-400">
                            JPEG
                          </div>
                        </div>

                        <div className="fileName">
                          {/* <div className="position-absolute ml-55"> */}
                          <div >
                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                              {" "}
                              {values?.CNICFileFrontName}
                            </p>

                          </div>
                        </div>
                      </div>

                    </>
                    ) : (
                      <>
                        {Object.keys(values.CNICFileFront).map((x) => {
                          // console.log(values.CNICFileFront[x])
                          return (
                            <>
                              <div className="d-block d-sm-table mb-3">
                                <div className="Circularprogress yellow">
                                  <span className="Circularprogress-left">
                                    <span className="Circularprogress-bar"></span>
                                  </span>
                                  <span className="Circularprogress-right">
                                    <span className="Circularprogress-bar"></span>
                                  </span>
                                  <div className="Circularprogress-value t-pink fs12 fw-400">
                                    {getSecondPart(
                                      values.CNICFileFront[x].type
                                    ).toUpperCase()}
                                  </div>
                                </div>

                                <div className="fileName">
                                  {/* <div className="position-absolute ml-55"> */}
                                  <div >
                                    <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                      {values.CNICFileFront[x].name}
                                    </p>
                                    <div>
                                      <p className="m-0 t-grey-400 fw-400 fs14 text-center ">
                                        {Math.round(
                                          values.CNICFileFront[x].size / 1024
                                        )}
                                        kb /
                                        {Math.round(
                                          values.CNICFileFront[x].size / 1024
                                        )}
                                        kb
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}

                      </>
                    )}

                    {values?.CNICFileBackName ? (<>
                      <div className="d-block d-sm-table mt8">
                        <div className="Circularprogress yellow">
                          {" "}
                          <span className="Circularprogress-left">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>{" "}
                          <span className="Circularprogress-right">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>
                          <div className="Circularprogress-value t-pink fs12 fw-400">
                            JPEG
                          </div>
                        </div>

                        <div className="fileName">
                          {/* <div className="position-absolute ml-55"> */}
                          <div >
                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                              {" "}
                              {values?.CNICFileBackName}
                            </p>

                          </div>
                        </div>
                      </div>

                    </>
                    ) : (
                      <>
                        {Object.keys(values.CNICFileBack).map((x) => {
                          // console.log(values.CNICFileBack[x])
                          return (
                            <>
                              <div className="d-block d-sm-table mb-3 ">
                                <div className="Circularprogress yellow">
                                  <span className="Circularprogress-left">
                                    <span className="Circularprogress-bar"></span>
                                  </span>
                                  <span className="Circularprogress-right">
                                    <span className="Circularprogress-bar"></span>
                                  </span>
                                  <div className="Circularprogress-value t-pink fs12 fw-400">
                                    {getSecondPart(
                                      values.CNICFileBack[x].type
                                    ).toUpperCase()}
                                  </div>
                                </div>

                                <div className="fileName">
                                  {/* <div className="position-absolute ml-55"> */}
                                  <div >
                                    <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                      {values.CNICFileBack[x].name}
                                    </p>
                                    <div>
                                      <p className="m-0 t-grey-400 fw-400 fs14 text-center ">
                                        {Math.round(
                                          values.CNICFileBack[x].size / 1024
                                        )}
                                        kb /
                                        {Math.round(
                                          values.CNICFileBack[x].size / 1024
                                        )}
                                        kb
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}

                      </>
                    )
                    }



















                    {values?.sendSalerySlipName ? (<>
                      <p className="fs18 fw-500 t-grey-400 my-3">Proof on Income</p>
                      <div className="d-block d-sm-table">
                        <div className="Circularprogress yellow">
                          {" "}
                          <span className="Circularprogress-left">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>{" "}
                          <span className="Circularprogress-right">
                            {" "}
                            <span className="Circularprogress-bar"></span>{" "}
                          </span>
                          <div className="Circularprogress-value t-pink fs12 fw-400">
                            PDF
                          </div>
                        </div>

                        <div className="fileName">
                          {/* <div className="position-absolute ml-55"> */}
                          <div >
                            <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                              {" "}
                              {values?.sendSalerySlipName}
                            </p>

                          </div>
                        </div>
                      </div>

                    </>
                    ) : (
                      <>
                        {Object.keys(values.SalerySlip).map((x) => {

                          return (
                            <>
                              <p className="fs18 fw-500 t-grey-400 my-3">Proof of Income</p>
                              <div className="d-block d-sm-table">
                                <div className="Circularprogress yellow">
                                  <span className="Circularprogress-left">
                                    <span className="Circularprogress-bar"></span>
                                  </span>
                                  <span className="Circularprogress-right">
                                    <span className="Circularprogress-bar"></span>
                                  </span>

                                  <div className="Circularprogress-value t-pink fs12 fw-400">
                                    {getSecondPart(
                                      values.SalerySlip[x].type
                                    ).toUpperCase()}
                                  </div>
                                </div>

                                <div className="fileName">
                                  {/* <div className="position-absolute ml-55"> */}
                                  <div >
                                    <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                      {values.SalerySlip[x].name}
                                    </p>
                                    <div>
                                      <p className="m-0 t-grey-400 fw-400 fs14 text-center ">
                                        {Math.round(
                                          values.SalerySlip[x].size / 1024
                                        )}
                                        kb /
                                        {Math.round(
                                          values.SalerySlip[x].size / 1024
                                        )}
                                        kb
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </>
                    )}




                    {/* upload additional documents  */}

                    {values?.AdditionalDocumentsName ? (
                      <>
                        <p className="fs18 fw-500 t-grey-400 my-3">Additional Documents</p>
                        {values?.AdditionalDocumentArray?.map(apiDocumentData => {
                          return (
                            <>



                              {/* already saved */}
                              <div className="d-flex justify-content-between mt8">
                                <div className="d-block d-sm-table">
                                  <div className="Circularprogress yellow">
                                    {" "}
                                    <span className="Circularprogress-left">
                                      {" "}
                                      <span className="Circularprogress-bar"></span>{" "}
                                    </span>{" "}
                                    <span className="Circularprogress-right">
                                      {" "}
                                      <span className="Circularprogress-bar"></span>{" "}
                                    </span>
                                    <div className="Circularprogress-value t-pink fs12 fw-400">
                                      {/* PDF */}

                                      {apiDocumentData?.file ? getSecondPart(
                                        apiDocumentData?.file[0]?.type
                                      ).toUpperCase() :

                                        apiDocumentData?.name?.split(".").pop().toUpperCase()

                                      }

                                    </div>
                                  </div>

                                  <div className="fileName">
                                    <div >
                                      <p className="m-0 t-grey-600 fs16 fw-500 dotted">
                                        {" "}
                                        {apiDocumentData?.title ? apiDocumentData?.title : apiDocumentData?.name}
                                      </p>

                                    </div>
                                  </div>
                                </div>



                                {/* <div className="my-3 cursor edge p-1 w30">


                                  <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
                                    className="mx-auto d-block"
                                    onClick={() =>
                                      removeFile(apiDocumentData?.id)
                                    }
                                  />
                                </div> */}
                              </div>

                            </>
                          )
                        })}
                        {/* <div className="my-3 cursor bg-Pink edge p-1">

<img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/Group 208.png" alt="cross"
className="mx-auto d-block"
onClick={() =>
handleDrctChange(
"AdditionalDocumentsName",
""
)
}
/>
</div> */}
                      </>) : (<>

                        {values.AdditionalDocumentArray ? (
                          <>
                            <p className="fs18 fw-500 t-grey-400 my-3">Additional Documents</p>
                            {values.AdditionalDocumentArray.map(x => {
                              return (
                                <>

                                  {/* recently uploaded */}
                                  <div className="d-flex justify-content-between mt8">
                                    {/* <div>
                                          <p>{x.name}</p>
                                        </div> */}
                                    <div className="d-block d-sm-table">
                                      <div className="Circularprogress yellow">

                                        <span className="Circularprogress-left">

                                          <span className="Circularprogress-bar"></span>
                                        </span>
                                        <span className="Circularprogress-right">

                                          <span className="Circularprogress-bar"></span>
                                        </span>
                                        <div className="Circularprogress-value t-pink fs12 fw-400">
                                          {getSecondPart(
                                            x?.file[0]?.type
                                          ).toUpperCase()}
                                        </div>
                                      </div>

                                      <div className="fileName">
                                        <div >
                                          <p className="m-0 t-grey-600 fs16 fw-500 dotted">

                                            {x?.file[0]?.name}
                                          </p>
                                          <div>
                                            <p className="m-0 t-grey-400 fw-400 fs14 ">

                                              {Math.round(
                                                x?.file[0]?.size / 1024
                                              )}
                                              kb /
                                              {Math.round(
                                                x?.file[0]?.size / 1024
                                              )}
                                              kb
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                </>
                              )
                            })}
                          </>
                        ) : (
                          <>

                          </>
                        )}
                      </>)}








                    <button
                      className="btn-outlined fs16 px-3 py-2 mt-3 w-sm-100"
                      // onClick={() => handleDrctChange("step", 4)}
                      onClick={() => handleDocumentEditClick()}
                    >
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br />
            {console.log('error tab is=============>', responseError)}
            {errorTab &&
              <div className="row error" >
                <div className="col-md-6 mb-3">
                  <div className="row">
                    {/* <img src={warning} height="45" className=" col-sm-2 w-auto" alt='err' /> */}
                    <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/warning.png" height="45" className=" col-sm-2 w-auto" alt='err' />
                    <p className="col-sm-10 fw-400 fs14 t-grey-800 ml-2 mb-0">
                      An error occurred in your submission with the following information: <b>{responseError}</b> In case of questions please contact our customer support on the following channels:               </p>
                  </div>
                </div>
                <div className="col-md-6 d-inline-flex flex-wrap justify-content-between">
                  <div className="px-3">
                    <p className=" fw-500 fs-14 t-grey-400 mb0">UAN</p>
                    <p className="fw-800 fs14 t-grey-800"> 021 111 639 825 Ext 147</p>
                  </div>
                  <div className="px-3">
                    <p className=" fw-500 fs-14 t-grey-400 mb0">WhatsApp</p>
                    <p className="fw-800 fs14 t-grey-800">
                      <a className="underline" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a>


                    </p>
                  </div>
                  <div className="px-3">
                    <p className="fw-500 fs-14 t-grey-400 mb0">Email</p>
                    <p className="fw-800 fs14 t-grey-800">cs@nextcapital.com.pk</p>
                  </div>
                </div>
              </div>
            }
            <hr className="t-grey-200"></hr>
            <div className="mb-3 row w-100" style={{ marginTop: "10px" }}>
              <Disclaimer />

              <div className="col-lg-5 col-xl-4 text-end ">
                <form onSubmit={handleSubmit}>

                  <div className="Half2">



                    <button
                      className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn text-nowrap disableBtn"
                      type='button'
                      disabled={sendingReq == true}
                      onClick={() => handleBackBtn()}
                    >
                      Back
                    </button>

                    <button
                      className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 disableBtn naviBtn"
                      type="button"
                      disabled={sendingReq == true}
                      onClick={openProceedToSubmitModel}
                      data-toggle="proceedSubmitModal"
                      data-target="#proceedSubmitModal"

                    >
                      {sendingReq ? (

                        <div className="whitespinner">
                          <div className="bounce1"></div>
                          <div className="bounce2"></div>
                          <div className="bounce3"></div>
                        </div>
                      ) : (
                        <>Submit</>
                      )}


                    </button>
                  </div>

                  {/*               
                  <button
                    className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type="button"
                   
                    onClick={() => handleBackBtn()}
                  >
                    Back
                  </button>

                  <button
                    type="button"
                    onClick={openProceedToSubmitModel}
                    className="NavButton btn mb-2 px-3 py-2"
                    data-toggle="proceedSubmitModal"
                    data-target="#proceedSubmitModal"
                  >
                    {sendingReq ? (
                   
                      <div className="whitespinner">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                      </div>
                    ) : (
                      <>Submit</>
                    )}
                  </button> */}

                </form>
                <p className="text-danger fs12 text-end">{error}</p>
              </div>
            </div>
          </div>

          <div className="modal" tabIndex="-1" role="dialog" id="myModal">
            <div className="modal-dialog centerr" role="document">
              <div className="modal-content">
                <div className="modal-body container text-center ">
                  <p className="mb-0 fs32 fw-800 ">Thank You!</p>
                </div>
                {editFormStatus == "true" ? (
                  <div className="modal-body container text-center">
                    <p className=" cursorPointer t-grey-2000">
                      We’re now taking the last set up steps as we speak. We’ll contact you once they’re completed!
                    </p>
                  </div>
                ) : (
                  <div className="modal-body container text-center ">
                    <p className=" cursorPointer t-grey-2000">
                      Your account opening form has been submitted. You will be provided with an OTP once the
                      required verification is completed. This may take up to 2 working days. <br /> <br />

                      If you're a resident in Pakistan your OTP will be sent to you via SMS from 9646. If you're a non-resident your OTP will be sent to you via  email from NCCPL. Please occasionally check your junk mail to not miss  the OTP. <br /> <br />

                      Once you receive the OTP please come back to submit it. <br /> <br />

                      NCCPL is the institution responsible for opening trading accounts
                    </p>
                  </div>

                )}

                <div className="modal-body container mb-3">


                  {editFormStatus == "true" ? (
                    <button
                      type="button"
                      className="backDashboardButton  btn fw-800 close"
                      data-dismiss="modal"
                      onClick={() => handleAPICSuccessScreen()}
                    >
                      Back to Dashboard
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="backDashboardButton  btn fw-800 close"
                      data-dismiss="modal"
                      onClick={() => backTodaskboard()}
                    >
                      Back to Dashboard
                    </button>
                  )}



                </div>
              </div>
            </div>
          </div>
          <div className="modal" tabIndex="-1" role="dialog" id="SaveExitModal">
            <div className="modal-dialog centerr" role="document">
              <div className="modal-content">
                <div className="modal-header p-0">
                  <h5 className="modal-title t-pink">Information Submited</h5>

                  <span className="close cross">&times;</span>
                </div>
                <div className="modal-body px-0">
                  <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                    Thank You your information has been saved.
                  </p>
                </div>
                <div className="modal-footer px-0">
                  <NavLink to="/Dashboard">
                    <button
                      type="button"
                      className="btn-outlined fs16 px-3 py-2 mx-2 close"
                      data-dismiss="modal"
                    >
                      OK
                    </button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>



          {/* <<<<<<<<<<<<<<<<<<<< ========================== Proceed to subnmit ====================>>>>>>>>>>>>>>>> */}
          {showProceedPopup == true &&
            <div className="modal" tabIndex="-1" role="dialog" id="proceedSubmitModal">
              <div className="modal-dialog centerr" role="document">



                <div className="modal-content">
                  <div className="modal-header text-center border-0 mx-auto">
                    <h1
                      className="modal-title fw-bolder mt-5"
                      id="exampleModalLabel"
                    >
                      Submit Form?
                    </h1>
                    {/* <span className="close cross">&times;</span> */}
                  </div>
                  <div className=" confirm-modal-body text-center">
                    {/* <div className="modal-body text-center"> */}
                    <p className="m-0 fw-100">
                      Once you submit you won't be able to make any further
                    </p>
                    <p className="p-0 ">
                      changes. Are you sure you wish to proceed ?
                    </p>
                    <form onSubmit={handleSubmit}>

                      <div className="row mt">
                        <div className="col-6">
                          <button
                            type="button"
                            className="btn-confirmation-cancel px-3 py-2 w-100 close"
                            data-dismiss="proceedSubmitModal"
                            data-toggle="span"
                            data-target="#proceedSubmitModal"
                          >
                            Cancel
                          </button>
                        </div>
                        <div className="col-6">
                          <button
                            type="submit"
                            className="NavButton btn px-3 py-2 w-100"
                          >
                            Proceed
                          </button>
                        </div>

                      </div>
                    </form>
                  </div>
                </div>







              </div>
            </div>

          }
        </div>
      </div>
    </div>
  );
};

export default Confirmation;


